// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto
}

.ps__rail-x {
    display: none;
    opacity: 0;
    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    height: 15px;
    bottom: 0;
    position: absolute
}

.ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    width: 15px;
    right: 0;
    position: absolute
}

.ps--active-x>.ps__rail-x,
.ps--active-y>.ps__rail-y {
    display: block;
    background-color: transparent
}

.ps--focus>.ps__rail-x,
.ps--focus>.ps__rail-y,
.ps--scrolling-x>.ps__rail-x,
.ps--scrolling-y>.ps__rail-y,
.ps:hover>.ps__rail-x,
.ps:hover>.ps__rail-y {
    opacity: .6
}

.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-x:focus,
.ps .ps__rail-x:hover,
.ps .ps__rail-y.ps--clicking,
.ps .ps__rail-y:focus,
.ps .ps__rail-y:hover {
    background-color: #eee;
    opacity: .9
}

.ps__thumb-x {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color .2s linear, height .2s ease-in-out;
    -webkit-transition: background-color .2s linear, height .2s ease-in-out;
    height: 6px;
    bottom: 2px;
    position: absolute
}

.ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color .2s linear, width .2s ease-in-out;
    -webkit-transition: background-color .2s linear, width .2s ease-in-out;
    width: 6px;
    right: 2px;
    position: absolute
}

.ps__rail-x.ps--clicking .ps__thumb-x,
.ps__rail-x:focus>.ps__thumb-x,
.ps__rail-x:hover>.ps__thumb-x {
    background-color: #999;
    height: 11px
}

.ps__rail-y.ps--clicking .ps__thumb-y,
.ps__rail-y:focus>.ps__thumb-y,
.ps__rail-y:hover>.ps__thumb-y {
    background-color: #999;
    width: 11px
}

@supports (-ms-overflow-style:none) {
    .ps {
        overflow: auto !important
    }
}

@media screen and (-ms-high-contrast:active),
(-ms-high-contrast:none) {
    .ps {
        overflow: auto !important
    }
}`, "",{"version":3,"sources":["webpack://./src/vendor/perfect-scrollbar/css/perfect-scrollbar.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,2DAA2D;IAC3D,mEAAmE;IACnE,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,2DAA2D;IAC3D,mEAAmE;IACnE,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;;;IAMI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,+DAA+D;IAC/D,uEAAuE;IACvE,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,8DAA8D;IAC9D,sEAAsE;IACtE,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;;IAGI,sBAAsB;IACtB;AACJ;;AAEA;;;IAGI,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;QACI;IACJ;AACJ","sourcesContent":[".ps {\n    overflow: hidden !important;\n    overflow-anchor: none;\n    -ms-overflow-style: none;\n    touch-action: auto;\n    -ms-touch-action: auto\n}\n\n.ps__rail-x {\n    display: none;\n    opacity: 0;\n    transition: background-color .2s linear, opacity .2s linear;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    height: 15px;\n    bottom: 0;\n    position: absolute\n}\n\n.ps__rail-y {\n    display: none;\n    opacity: 0;\n    transition: background-color .2s linear, opacity .2s linear;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    width: 15px;\n    right: 0;\n    position: absolute\n}\n\n.ps--active-x>.ps__rail-x,\n.ps--active-y>.ps__rail-y {\n    display: block;\n    background-color: transparent\n}\n\n.ps--focus>.ps__rail-x,\n.ps--focus>.ps__rail-y,\n.ps--scrolling-x>.ps__rail-x,\n.ps--scrolling-y>.ps__rail-y,\n.ps:hover>.ps__rail-x,\n.ps:hover>.ps__rail-y {\n    opacity: .6\n}\n\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y.ps--clicking,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-y:hover {\n    background-color: #eee;\n    opacity: .9\n}\n\n.ps__thumb-x {\n    background-color: #aaa;\n    border-radius: 6px;\n    transition: background-color .2s linear, height .2s ease-in-out;\n    -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n    height: 6px;\n    bottom: 2px;\n    position: absolute\n}\n\n.ps__thumb-y {\n    background-color: #aaa;\n    border-radius: 6px;\n    transition: background-color .2s linear, width .2s ease-in-out;\n    -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n    width: 6px;\n    right: 2px;\n    position: absolute\n}\n\n.ps__rail-x.ps--clicking .ps__thumb-x,\n.ps__rail-x:focus>.ps__thumb-x,\n.ps__rail-x:hover>.ps__thumb-x {\n    background-color: #999;\n    height: 11px\n}\n\n.ps__rail-y.ps--clicking .ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y:hover>.ps__thumb-y {\n    background-color: #999;\n    width: 11px\n}\n\n@supports (-ms-overflow-style:none) {\n    .ps {\n        overflow: auto !important\n    }\n}\n\n@media screen and (-ms-high-contrast:active),\n(-ms-high-contrast:none) {\n    .ps {\n        overflow: auto !important\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
